import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
  Tooltip,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';


import 'react-accessible-accordion/dist/fancy-example.css';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import callapiobj from '../../../Common/api';
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import DatePicker from "react-datepicker";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';


var url = window.location.hostname;
var port = window.location.port;
var assign_arr= [];
var unassign_arr = [];
var data_type = "";
var From_Date_val;
var to_Date_val;
var dispatchData = {};

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.state = {
      ShowpopupLoader: false,
      showValidatedOption: false,
      modalNew: false,
      FailedModal: false,
      prn_id: "",
      totalcost: "",
      total_value: "",
      invoice: "",
      prod_id_state : false,
      total_item: "",
      inboundData: [],
      EditModal: false,
      loader1: false,
      disable_asn_button: true,
      showCost: true,
      showPO: true,
      showInvoice: true,
      assignLoader: false,
      showUnAssignedOrder: false,
      SuccessConfirmmodal1: false,
      showFetchDispatchData: false,
      failed_message: "",
      loadingconfirmbtn: false,
      loading: false,
      loading_overlay: false,
      pr_type: "1",
      stock_type: "0"
    };
  }

 

  toggleOKSuccess= () =>{
   window.location.reload();
  }

  toggleNew= () =>{
    this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
  }


  toggle = () =>{
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  Failedtoggle= () =>{
    this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
  }


  toggleFailed = () =>{
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

 

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }
    var Location = this.getCookie("selectedLocation");
    var cookieUsername = this.getCookie("token");
    var access_token = cookieUsername
    this.setState(
      {
        selectedLocation: Location,
        userName: access_token
        
      },
      () => {
        
        this.getInboundList();
        
      }
    );

  }

  getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

 

  onInboundChange = (e) => {
    const value = e.target.value;
    this.setState({
      inbound: value,
      
    });
  };

   
 

   

ConfirmAssignData() {
   addAnalytics('Purchase Return', 'Redirect to review page');
  if(this.state.pr_type == 1){
    window.location.href = "/receiving/confirm_saleable"
  }else{
    window.location.href = "/receiving/confirm_non_saleable"

  }
  
   /* const payload = {
        po_number: this.state.po_number_data,
    };

    API.post('/receiving/poShortClose/', { param: payload })

    .then((response) => response.data)

    .then((data) => {

      console.log(data);

      if(data.status === true){
        this.setState({
          success_message: data.reason
        })
        this.toggleNew();
      }else{
        this.setState({
          failed_message: data.reason
        })
        this.Failedtoggle();
      }
  
     
    })

    .then(async () => {
      
    });*/
}

onHandleChange = (e) =>{
  this.setState({[e.target.name]: e.target.value})
  
}

onOptionChange = (e)=>{
  this.setState({
    pr_type: e.target.value
  })
  if(e.target.value === "1"){
    this.setState({
      showCost: true,
      showInvoice: true,
      showPO: true,
      showFetchDispatchData: false
    })
  }else{
    this.setState({
      showCost: false,
      showInvoice: false,
      showPO: false, 
      showFetchDispatchData: false
    })
  }
}
   



  getInboundList = () => {
    
      const payload = {
        location: this.state.selectedLocation,
    };

    API.post('/receiving/fetchInboundDeliveryList/', { param: payload })

    .then((response) => response.data)

    .then((data) => {
  
      this.setState({ inboundData: data });
    })

    .then(async () => {
      
    });
  }

   changeReturnQty = (evt,index,id) => {
    
    const {arr_data1} = this.state;
    var return_qty = parseInt(evt.target.value);
    
    var objIndex = arr_data1.findIndex((obj => obj.id == id));
    arr_data1[objIndex]['return_qty'] = return_qty

    console.log(arr_data1, "arr_data1");
    this.setState({
      arr_data1: arr_data1,
      tableRowsMap: this.assembleDispatchData(arr_data1),
    });
    
  };

  changeCostQty = (evt,index,id) => {
    
    const {arr_data1} = this.state;
    var return_rate = evt.target.value;
    
    var objIndex = arr_data1.findIndex((obj => obj.id == id));
    arr_data1[objIndex]['return_rate'] = return_rate
    this.setState({
      arr_data1: arr_data1,
      tableRowsMap: this.assembleDispatchData(arr_data1),
    });
    
  };

   addProductWithoutRate = (po_number, asn_number, invoice, cost, return_qty, stock_type, product_id,bin_id) =>{
    this.setState({
      loading_overlay: true
    })
    /*if(return_rate == "" || return_rate == undefined || return_rate == null){
        this.setState({
          failed_message: "Please Enter Rate",
          loading_overlay: false
        })
        this.Failedtoggle();
        return false;
    }*/

    if(return_qty == "" || return_qty == undefined || return_qty == null){
        this.setState({
          failed_message: "Please Enter Return Qty",
          loading_overlay: false
        })
        this.Failedtoggle();
        return false;
    }
     const payload = {
        po_number: po_number,
        asn_number: asn_number,
        invoice_number: invoice,
        cost: cost,
        quantity: return_qty,
        stock_type: stock_type,
        product_id: product_id,
        bin_id : bin_id
        //cost: return_rate
    }

     addAnalytics('Purchase Return', 'Add Return Qty', payload);

  

    API.post('/picking/addPurchaseReturns', { param: payload })

    .then((response) => response.data)

    .then((data) => {

      console.log(data);
      if(data.status == true){
        this.setState({
          success_message: data.message,
          loading_overlay: false
        })
        this.toggleNew();
        //this.fetchDispatch();
      }else{
        this.setState({
          failed_message: data.message,
          loading_overlay: false
        })
        this.Failedtoggle();

      }
  
      //this.setState({ inboundData: data });
    })

    .then(async () => {
      
    });
  }

  addProduct = (po_number, asn_number, invoice, cost, return_qty, stock_type, product_id, return_rate,bin_id) =>{
    this.setState({
      loading_overlay: true
    })
    if(return_rate == "" || return_rate == undefined || return_rate == null){
        this.setState({
          failed_message: "Please Enter Rate",
          loading_overlay: false
        })
        this.Failedtoggle();
        return false;
    }

    if(return_qty == "" || return_qty == undefined || return_qty == null){
        this.setState({
          failed_message: "Please Enter Return Qty",
          loading_overlay: false
        })
        this.Failedtoggle();
        return false;
    }
     const payload = {
        po_number: po_number,
        asn_number: asn_number,
        invoice_number: invoice,
        //cost: cost,
        quantity: return_qty,
        stock_type: stock_type,
        product_id: product_id,
        cost: return_rate,
        bin_id : bin_id
    }
     addAnalytics('Purchase Return', 'Add Return Qty', payload);

  

    API.post('/picking/addPurchaseReturns', { param: payload })

    .then((response) => response.data)

    .then((data) => {

      console.log(data);
      if(data.status == true){
        this.setState({
          success_message: data.message,
          loading_overlay: false
        })
        this.toggleNew();
        //this.fetchDispatch();
      }else{
        this.setState({
          failed_message: data.message,
          loading_overlay: false
        })
        this.Failedtoggle();

      }
  
      //this.setState({ inboundData: data });
    })

    .then(async () => {
      
    });
  }

 

addProduct1 = (return_qty, stock_type, product_id, return_rate, bin_id) =>{
     this.setState({
      loading_overlay: true
    })

     if(return_rate == "" || return_rate == undefined || return_rate == null){
        this.setState({
          failed_message: "Please Enter Rate",
          loading_overlay: false
        })
        this.Failedtoggle();
        return false;
    }

     if(return_qty == "" || return_qty == undefined || return_qty == null){
        this.setState({
          failed_message: "Please Enter Return Qty",
          loading_overlay: false
        })
        this.Failedtoggle();
        return false;
    }
     const payload = {
        quantity: return_qty,
        stock_type: stock_type,
        product_id: product_id,
        cost: return_rate,
        bin_id: bin_id

    };
     addAnalytics('Purchase Return', 'Add Return Qty', payload);

    API.post('/picking/addPurchaseReturns', { param: payload })

    .then((response) => response.data)

    .then((data) => {

      console.log(data);
      if(data.status == true){
        this.setState({
          success_message: data.message,
          loading_overlay: false
        })
        this.toggleNew();
        this.fetchDispatch();
      }else{
        this.setState({
          failed_message: data.message,
          loading_overlay: false
        })
        this.Failedtoggle();

      }
  
      //this.setState({ inboundData: data });
    })

    .then(async () => {
      
    });
  }

 
   


   





  assembleDispatchData = (dispatchData) => {
    console.log(dispatchData, "dispatchData");
    console.log("pr_type",this.state.pr_type);
    let DispatchData = dispatchData.map((post, index) => {

       if(this.state.pr_type == 1 && this.state.stock_type == "0"){
        return {
        product : post.product_code,
        mrp: post.mrp,
        bin_address : post.bin_address,
        available_qty: post.available_qty,
        PO: post.po_number,
        asn: post.asn_number,
        invoice_no: post.invoice_number, 
        cost: post.cost,
        grn_qty: post.quantity,
        return_qty: <input  Value={post.return_qty}  style={{fontSize: 12, height: 31, width: 80, margin: 'auto'}} type = "text"  className="form-control" placeholder="Invoice Qty"  onChange={(evt) => this.changeReturnQty(evt,index, post.id)} /> ,
        //return_rate: <input  Value={post.return_rate}  style={{fontSize: 12, height: 31, width: 80}} type = "text"  className="form-control" placeholder="Rate"  onChange={(evt) => this.changeCostQty(evt,index, post.id)}  />,
        action:  <img style={{width: 40, height: 38, cursor: 'pointer'}}
                    src={require("../../../../images/add_product.png")}
                    onClick={(evt) => this.addProductWithoutRate(post.po_number, post.asn_number, post.invoice_number, post.cost, post.return_qty, this.state.stock_type, post.product_id,post.bin_address)}
                    
                  />,

      };
    }

      else if(this.state.pr_type == 1){
        return {
        product : post.product_code,
        mrp: post.mrp,
        bin_address : post.bin_address,
        available_qty: post.available_qty,
        PO: post.po_number,
        asn: post.asn_number,
        invoice_no: post.invoice_number, 
        cost: post.cost,
        grn_qty: post.quantity,
        return_qty: <input  Value={post.return_qty}  style={{fontSize: 12, height: 31, width: 80,}} type = "text"  className="form-control" placeholder="Invoice Qty"  onChange={(evt) => this.changeReturnQty(evt,index, post.id)} /> ,
        return_rate: <input  Value={post.return_rate}  style={{fontSize: 12, height: 31, width: 80}} type = "text"  className="form-control" placeholder="Rate"  onChange={(evt) => this.changeCostQty(evt,index, post.id)}  />,
        action:  <img style={{width: 40, height: 38, cursor: 'pointer'}}
                    src={require("../../../../images/add_product.png")}
                    onClick={(evt) => this.addProduct(post.po_number, post.asn_number, post.invoice_number, post.cost, post.return_qty, this.state.stock_type, post.product_id, post.return_rate,post.bin_address)}
                    
                  />,

      };
    }else{
       return {
        product : post.product_code,
        mrp: post.mrp,
        bin_id: post.bin_id,
        storage_type: post.storage_type,
        mrp: post.mrp,
        available_qty: post.available_qty,
        
        return_qty: <input  Value={post.return_qty}  style={{fontSize: 12, height: 31, width: 120,}} type = "text"  className="form-control" placeholder="Invoice Qty"  onChange={(evt) => this.changeReturnQty(evt,index, post.id)} /> ,
        return_rate: <input  Value={post.return_rate}  style={{fontSize: 12, height: 31, width: 80}} type = "text"  className="form-control" placeholder="Rate"  onChange={(evt) => this.changeCostQty(evt,index, post.id)}  />,
        action: <img style={{width: 40, height: 38, cursor: 'pointer'}}
                    src={require("../../../../images/add_product.png")}
                    onClick={(evt) => this.addProduct1(post.return_qty, post.stock_type, post.product_id, post.return_rate, post.bin_id)}
                  />,
        
      };
    }
      
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };




  fetchDispatch = (order_no) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
      showFetchDispatchData: true,
      //showFetchDispatchData: true
    });


    var batch = localStorage.getItem('batch_id');

    const payload = {
    ...(this.state.product ? { product_code: this.state.product } : {}),
    ...(this.state.mrp ? { mrp: this.state.mrp } : {}),
    ...(this.state.cost ? { cost: this.state.cost } : {}),
    ...(this.state.invoice ? { invoice_no: this.state.invoice } : {}),
    ...(this.state.stock_type ? { stock_type: this.state.stock_type } : {}),
    ...(this.state.pr_type ? { by_invoice: this.state.pr_type } : {}),
  };

  addAnalytics('Purchase Return', 'Search Filter', payload);



//API.get('/picking/fetchPurchaseReturnProducts?product_code='+this.state.product+'&mrp='+this.state.mrp+'&cost='+this.state.cost+'&invoice_no='+this.state.invoice+'&po_number='+this.state.PO+'&stock_type='+this.state.stock_type+'&by_invoice='+this.state.pr_type)
      callapiobj.get('/picking/fetchPurchaseReturnProducts', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log(data);
        if(data.status == false){
          this.setState({
            failed_message: data.message,
            loading: false
          })
          this.Failedtoggle();

        }else{

        this.setState({
          showFetchDispatchData: true,
          prn_id: data.prd_id,
          //po_number_data: data.data[0].po_number,
        });

        let AssignData = data.products.map((item) => ({
          ...item,
          return_qty: "",
          return_rate: "",
        }));

        var totalcost= 0;
        var available_qty_val = 0;

        for(var i = 0 ; i< AssignData.length; i++){
          totalcost += AssignData[i].mrp * AssignData[i].available_qty;
          available_qty_val += AssignData[i].available_qty;
        }
     

        
        
     

        this.setState({
         
          arr_data1: AssignData,
          total_item: AssignData.length,
          total_value: available_qty_val,
          totalcost: totalcost,

          tableRowsMap: this.assembleDispatchData(AssignData),
          //tableRowsMap1: this.assembleDispatchData1(data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      }
      })
      .catch(function(error) {});
  };






  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modalNew , Failedmodal} = this.state;
    if(this.state.pr_type == "1" && this.state.stock_type == "0"){

     dispatchData = {
      columns: [
       
        {
          label : "Product",
          field : "product",
          width : 140,
        },
        {
          label : "Bin Address",
          field : "bin_address",
          width : 130
        },

        {
          label: "Mrp",

          field: "mrp",
          width: 120,
        },
        
        {
          label: "Available Qty",

          field: "available_qty",
          width: 120,
        },
        {
          label: "PO Number",

          field: "PO",
          width: 200,
        },
        {
          label: "ASN Number",

          field: "asn",
          width: 200,
        },


        {
          label: "Invoice No.",

          field: "invoice_no",
          width: 200,
        },

        {
          label: "Cost",

          field: "cost",
          width: 130,
        },

        {
          label: "GRN Qty",

          field: "grn_qty",
          width: 100,
        },

        {
          label: "Return Qty",

          field: "return_qty",
          width: 130,
        },

         

         {
          label: "Action",

          field: "action",
          width: 130,
        },
       
        


      ],

      rows: this.state.tableRowsMap,
    };
  }
else if(this.state.pr_type == "1"){

     dispatchData = {
      columns: [
        {
          label : "Product",
          field : "product",
          width : 110,
        },

        {
          label: "Mrp",

          field: "mrp",
          width: 100,
        },
        {
          label : "Bin Address",
          field : "bin_address",
          width : 110
        },
        {
          label: "Available Qty",

          field: "available_qty",
          width: 120,
        },
        {
          label: "PO Number",

          field: "PO",
          width: 130,
        },
        {
          label: "ASN Number",

          field: "asn",
          width: 120,
        },


        {
          label: "Invoice No.",

          field: "invoice_no",
          width: 110,
        },

        {
          label: "Cost",

          field: "cost",
          width: 130,
        },

        {
          label: "GRN Qty",

          field: "grn_qty",
          width: 100,
        },

        {
          label: "Return Qty",

          field: "return_qty",
          width: 130,
        },

        {
          label: "Return Rate",

          field: "return_rate",
          width: 130,
        },

         

         {
          label: "Action",

          field: "action",
          width: 130,
        },
       
        


      ],

      rows: this.state.tableRowsMap,
    };
  }else{


     dispatchData = {
      columns: [
        {
          label : "Product",
          field : "product",
          width : 120,
        },

        {
          label: "Mrp",

          field: "mrp",
          width: 100,
        },

        {
          label: "Bin ID",

          field: "bin_id",
          width: 140,
        },

        {
          label: "Storage Type",

          field: "storage_type",
          width: 160,
        },
        
       
        {
          label: "Available Qty",

          field: "available_qty",
          width: 160,
        },
         {
          label: "Return Qty",

          field: "return_qty",
          width: 170,
        },



         {
          label: "Return Rate",

          field: "return_rate",
          width: 160,
        },

        {
          label: "Action",

          field: "action",
          width: 120,
        },

       
        


      ],

      rows: this.state.tableRowsMap,
    };


  }



    return (
      <Col xl={12}>
        
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <CardBody style={{ paddingTop: 10, height: 60, paddingBottom: 12 }}>
           

            <form className="form form--inline" onSubmit={handleSubmit}>

               <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '12%', float: 'left', marginRight: 14}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 180, marginRight: 10 }}
                    onChange={this.onOptionChange}
                  >
                    
                    <option value="1">By Sup Invoice </option>
                    <option value="0">W/O Invoice </option>

                       
                  </select>

                </div>
              </div>

               <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '12%', float: 'left', marginRight: 10, marginLeft: 5}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   

                    <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 180 }}
                    onChange={this.onHandleChange}
                    name="stock_type"
                  >
              
                    <option value="0">Saleable </option>
                    <option value="1">Non Saleable </option>

                       
                  </select>
                </div>
              </div>
             
               <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '12%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   

                   <input type = "text" className="form-control pr_return_text1" name="product" placeholder= "Prod" onChange={this.onHandleChange}/>
                </div>
              </div>

                <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '12%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   

                   <input type = "text" style={{width: 40}} className="form-control pr_return_text1" name="mrp" placeholder= "Mrp" onChange={this.onHandleChange}/>
                </div>
              </div>

              {this.state.showPO &&

                <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '12%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   

                   <input type = "text" className="form-control pr_return_text1" name = "PO" placeholder= "PO" onChange={this.onHandleChange}/>
                </div>
              </div>
            }

              {this.state.showInvoice &&
                <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '12%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   

                   <input type = "text" className="form-control pr_return_text1" name="invoice" placeholder= "Invoice" onChange={this.onHandleChange}/>
                </div>
              </div>
            }

              {this.state.showCost &&
                <div
                className="form__form-group"
                style={{ marginBottom: "0px", width: '12%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                   

                   <input type = "text" className="form-control pr_return_text1" name="cost" placeholder= "Cost" onChange={this.onHandleChange}/>
                </div>
              </div>
            }

                

              <div className="form__form-group" style={{width: '12%', float: 'left'}}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
             
            </form>
          </CardBody>

          {this.state.showFetchDispatchData && (
            <div>
           

              
             <div
                className="dispatchData stock_check_data style_table"
                style={{ marginTop: 1 }}
              >

  
                    <div style={{marginBottom: 8, width: '100%', float: 'left', marginTop: 12}}>
                    {this.state.prn_id != "" &&
                    <span style={{paddingBottom: 8, width: '15%', float: 'left'}}><strong>PRN ID: {this.state.prn_id}</strong></span>
                  }
                    <span style={{paddingBottom: 8, width: '15%', float: 'left'}}><strong>Items: {this.state.total_item}</strong></span>
                    <span style={{paddingBottom: 8, width: '15%', float: 'left'}}><strong>Total qty: {this.state.total_value}</strong></span>
                    <span style={{paddingBottom: 8 , width: '15%', float: 'left'}}><strong>Total Value: {this.state.totalcost}</strong></span>
                     <Button  style={{ width: '15%', float: 'left', marginLeft: 8, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => this.ConfirmAssignData()}>{this.state.asnLoader && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}Review</Button>
                    </div>
                    <div style={{marginBottom: 8, width: '100%', float: 'left'}}>
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="700px"
                  searching={false}
                  displayEntries={false}
                   paging= {false}
                  striped
                  bordered
                  data={dispatchData}
                />
                </div>


              </div>

                      
           

            </div>
          )}
        </Card>

         <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleNew}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h6>{this.state.success_message} </h6>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleNew}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

       

      

          <Modal isOpen={Failedmodal} backdrop="static" toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Failedtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

       
        
       
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
